// utils/interpreter_utils.js for TxnHistoryInterpreter.vue 
 
 export function looksLikeAddress(input) {
      const s = String(input || '').trim();
      const ethAddress = /^0x[a-fA-F0-9]{40}$/;
      const btcBase58 = /^[13][a-km-zA-HJ-NP-Z1-9]{25,34}$/;
      const btcBech32 = /^bc1[0-9ac-hj-np-z]{11,71}$/i;
      const tronAddress = /^T[1-9A-HJ-NP-Za-km-z]{33}$/;
      return ethAddress.test(s) || btcBase58.test(s) || btcBech32.test(s) || tronAddress.test(s);
    }
    export function inferNetwork(txHash, assetValue) {
      const s = String(txHash || '').trim();
      if (/^0x[a-fA-F0-9]{64}$/.test(s)) return 'Ethereum';
      const asset = String(assetValue || '').trim().toUpperCase();
      if (asset === 'BTC' || asset === 'XBT') return 'Bitcoin';
      if (asset === 'TRX' || asset === 'TRON') return 'Tron';
      if (/^[a-fA-F0-9]{64}$/.test(s)) return 'Hex64'; // Hex64 (BTC/TRON/other)
      return 'Unknown';
    }

   export function   isCsvLike(file) {
      const name = (file && file.name || '').toLowerCase();
      const extOk = name.endsWith('.csv');
      const type = (file && file.type || '').toLowerCase();
      const mimeOk = type === 'text/csv' || type === 'application/vnd.ms-excel' || type === 'text/plain';
      return extOk || mimeOk;
    }
     export function   detectMaxCols(rows) {
      let max = 0;
      for (let i = 0; i < rows.length; i++) if (Array.isArray(rows[i]) && rows[i].length > max) max = rows[i].length;
      return max;
    }   
       export function    firstHeaderMatch(headerNorm, list) {
      for (let i = 0; i < headerNorm.length; i++) if (list.includes(headerNorm[i])) return i;
      return -1;
    }
/** Build a simple "UTC-like" string from date/time cells. */
export function buildUtcTimestamp(dateStr, timeStr) {
  const d = (dateStr || '').toString().trim();
  const t = (timeStr || '').toString().trim();
  if (!d && !t) return null;
  if (d && t) return `${d} ${t} UTC`;
  if (d && !t) return `${d} 00:00:00 UTC`;
  return null; // time-only is too ambiguous
}
  export function  hasCsvInDataTransfer(dt) {
      if (!dt) return false;
      if (dt.items && dt.items.length) {
        for (let i = 0; i < dt.items.length; i++) {
          const it = dt.items[i];
          if (it.kind !== 'file') continue;
          if (it.type === 'text/csv' || it.type === 'application/vnd.ms-excel') return true;
        }
      }
      if (dt.files && dt.files.length) {
        const f = dt.files[0];
        if (!f) return false;
        const name = (f.name || '').toLowerCase();
        if (name.endsWith('.csv')) return true;
        const type = (f.type || '').toLowerCase();
        if (type === 'text/csv' || type === 'application/vnd.ms-excel') return true;
      }
      return false;
    }

export function detectTxidFromToCsvV1(headerRaw) {
  const normalize = (s) => String(s || '')
    .toLowerCase()
    .replace(/[“”"‘’'`]/g, '')
    .replace(/&/g, ' and ')
    .replace(/[_-]/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();

  const hn = Array.isArray(headerRaw) ? headerRaw.map(normalize) : [];

  // All tokens must appear as WHOLE WORDS in the header cell
  const findLike = (candidates) => {
    for (const cand of candidates) {
      const tokens = normalize(cand).split(' ').filter(Boolean);
      for (let i = 0; i < hn.length; i++) {
        const h = hn[i];
        const ok = tokens.every(t => new RegExp(`\\b${t}\\b`, 'i').test(h));
        if (ok) return i;
      }
    }
    return -1;
  };

  const col = {
    txnNo: findLike([
      'txn #','txn#','transaction #','transaction no','transaction number','txn number'
    ]),

    txid: findLike([
      'txid','tx id','tx hash','transaction hash','hash','txn hash','hash id'
    ]),

    // IMPORTANT: no single-word 'from' or 'to' to avoid "Subtotal"
    fromAddr: findLike([
      'from wallet address','from address','from wallet'
    ]),
    toAddr: findLike([
      'to wallet address','to address','to wallet','destination address','recipient address'
    ]),

    datetime: findLike([
      'date & time','date and time','date/time','datetime','date time','date','time'
    ]),

    coinQty: findLike([
      '# of coins','number of coins','no. of coins','coins','quantity','qty','amount (coins)','amount'
    ]),
    coinName: findLike([
      'coin name','asset','token','symbol','coin','currency'
    ])
  };

  const hasKey =
    (col.txid     >= 0) &&
    (col.toAddr   >= 0) &&
    (col.coinQty  >= 0) &&
    (col.coinName >= 0);

  if (!hasKey) return null;

  return {
    isCsvTxidFromToV1: true,
    columns: {
      txHash:       col.txid,
      toAddress:    col.toAddr,
      transferType: -1,
      asset:        col.coinName,
      amount:       col.coinQty
    },
    timeCol:       (col.datetime >= 0 ? col.datetime : -1),
    fromCol:       col.fromAddr,
    internalIdCol: col.txnNo
  };
}

/**
 * Detect "On-chain Ledger CSV" variant and map its columns.
 * Requires: Transaction Type, Amount 2, Currency 2, Destination.
 * Column A (Transaction ID) is an internal code -> not a blockchain tx hash.
 */
export function detectOnchainLedgerCsv(headerRaw, headerNorm) {
  const idx = (cands) => firstHeaderMatch(headerNorm, cands);

  const col = {
    internalId:   idx(['transaction id','transaction_id','txn id','txn_id']),
    initDate:     idx(['initiated date (utc)','initiated_date_(utc)','initiated date','initiated_date']),
    initTime:     idx(['initiated time (utc)','initiated_time_(utc)','initiated time','initiated_time']),
    compDate:     idx(['completed date (utc)','completed_date_(utc)','completed date','completed_date']),
    compTime:     idx(['completed time (utc)','completed_time_(utc)','completed time','completed_time']),
    txnType:      idx(['transaction type','transaction_type','type']),
    state:        idx(['state','status']),
    amount1:      idx(['amount 1','amount_1']),
    currency1:    idx(['currency 1','currency_1']),
    fee1:         idx(['fee 1','fee_1']),
    amount2:      idx(['amount 2','amount_2','amount2']),
    currency2:    idx(['currency 2','currency_2','currency2']),
    fee2:         idx(['fee 2','fee_2','fee2']),
    btcPrice:     idx(['btc price','btc_price','price btc','price_btc']),
    balance1:     idx(['balance 1','balance_1']),
    currency1b:   idx(['currency 1 (dup)','currency_1_dup','currency1_dup']),
    balanceBtc:   idx(['balance - btc','balance_btc','btc balance','btc_balance']),
    destination:  idx(['destination','to','to address','to_address'])
  };

  const hasKey =
    col.txnType    >= 0 &&
    col.amount2    >= 0 &&
    col.currency2  >= 0 &&
    col.destination>= 0;

  if (!hasKey) return null;

  return {
    isLedgerCsvV1: true,
    columns: {
      txHash:       -1,                // force OFF -> Column A is not a blockchain hash
      toAddress:    col.destination,
      transferType: col.txnType,
      asset:        col.currency2,
      amount:       col.amount2
    },
    timeCols: {
      initDate: col.initDate,
      initTime: col.initTime,
      compDate: col.compDate,
      compTime: col.compTime
    },
    internalIdCol: col.internalId
  };
}

 export function  normalizeHeader(s) {
      return String(s || '')
        .trim()
        .toLowerCase()
        .replace(/\(utc\)/g, 'utc')
        .replace(/[^a-z0-9]+/g, '_')
        .replace(/^_+|_+$/g, '')
        .replace(/_{2,}/g, '_');
    }
  export function   trimEmptyEdges(rows) {
     if (!Array.isArray(rows) || !rows.length) return [];
     // Trim trailing empty rows
     let lastNonEmptyRow = -1;
     for (let r = 0; r < rows.length; r++) {
       const row = rows[r] || [];
       const hasValue = row.some(v => String(v ?? '').trim() !== '');
       if (hasValue) lastNonEmptyRow = r;
     }
     if (lastNonEmptyRow >= 0) rows = rows.slice(0, lastNonEmptyRow + 1);
     else return [];
   
     // Trim trailing empty columns
     const cols = rows.reduce((m, r) => Math.max(m, (r || []).length), 0);
     let lastNonEmptyCol = -1;
     for (let c = 0; c < cols; c++) {
       let colHasValue = false;
       for (let r = 0; r < rows.length; r++) {
         const v = (rows[r] || [])[c];
         if (String(v ?? '').trim() !== '') { colHasValue = true; break; }
       }
       if (colHasValue) lastNonEmptyCol = c;
     }
     const cap = lastNonEmptyCol >= 0 ? lastNonEmptyCol + 1 : 0;
     if (cap <= 0) return [];
     return rows.map(r => (r || []).slice(0, cap));
   }
   /*
 export function     isTxHashLike(hash) {
      const s = String(hash || '').trim();
      const ethTx = /^0x[a-fA-F0-9]{64}$/;
      const hex64 = /^[a-fA-F0-9]{64}$/;
      return ethTx.test(s) || hex64.test(s);
    }*/
// utils/interpreter_utils.js
/** Convert a loose ISO-ish date string into epoch seconds if possible. */
export function toEpochSeconds(isoLike) {
  if (!isoLike) return null;
  const ms = Date.parse(isoLike);
  return Number.isFinite(ms) ? Math.floor(ms / 1000) : null;
}
 // Small local helper: infer network when tx hash is missing but address exists
   export function  inferNetworkFromAddrOrAsset(addr, asset) {
      const s = String(addr || '');
      const a = String(asset || '').toUpperCase();
      if (/^0x[a-fA-F0-9]{40}$/.test(s)) return 'ETH-like';
      if (/^T[1-9A-HJ-NP-Za-km-z]{33}$/.test(s)) return 'TRON';
      if (/^bc1[0-9ac-hj-np-z]{11,71}$/i.test(s) || /^[13][a-km-zA-HJ-NP-Z1-9]{25,34}$/.test(s)) return 'BTC';
      // Fallback to your existing heuristic
      return inferNetwork('', a);
    }
 


export function isTxHashLike(input) {
  const s = String(input || '').trim();
  if (!s) return false;

  // ETH: 0x + 64 hex
  const ethHash = /^0x[a-fA-F0-9]{64}$/;

  // Raw 64-hex (BTC, Tron, many EVM explorers that omit 0x, etc.)
  // Note: pure 64-digit decimal strings are rare as internal IDs; still hex allows 0-9a-fA-F.
 // const raw64Hex = /^[a-fA-F0-9]{64}$/;
// Only accept 64-hex if it contains at least one a-f character (pure decimal 64-digit blocked)
const raw64Hex = /^(?=.*[a-fA-F])[a-fA-F0-9]{64}$/;

  return ethHash.test(s) || raw64Hex.test(s);
}

      // Normalize and parse a numeric amount from diverse formats.
// Returns { num, disp } or null if not parseable.
// Normalize and parse a numeric amount from diverse formats.
// Returns { num, disp } or null if not parseable.
// - disp is a normalized ASCII string (may start with '-' if negative).
 export function parseAmount(raw) {
  if (raw == null) return null;
  let s = String(raw).trim();

  // Strip any Excel-style "treat as text" apostrophes (straight or curly)
  s = s.replace(/^[\u2019']+/, '');

  // Parentheses negative, e.g. "(3.50)"
  let neg = false;
  if (/^\(.*\)$/.test(s)) {
    neg = true;
    s = s.slice(1, -1);
  }

  // Normalize Unicode minus/dashes to ASCII hyphen
  s = s.replace(/[\u2212\u2010\u2011\u2012\u2013\u2014]/g, '-');

  // Remove currency symbols, percent, letters; keep digits, separators, sign
  s = s.replace(/[$€£¥₩₽₿%A-Za-z]/g, '');
  s = s.replace(/\u00A0/g, ''); // NBSP

  // Trailing minus (e.g. "3.5-")
  if (/-$/.test(s)) {
    neg = true;
    s = s.slice(0, -1);
  }

  // Remove spaces and any stray leading '+'
  s = s.replace(/\s+/g, '').replace(/^\+/, '');

  // Decide separators:
  if (s.includes(',') && s.includes('.')) {
    // "1,234.56" -> "1234.56"
    s = s.replace(/,/g, '');
  } else if (s.includes(',') && !s.includes('.')) {
    // EU decimal "3,50" -> "3.50"
    s = s.replace(/,/g, '.');
  } else {
    // Drop any stray commas
    s = s.replace(/,/g, '');
  }

  // Final cleanup: only one leading "-" and digits/one "."
  s = s.replace(/[^0-9.-]/g, '');
  s = s.replace(/(?!^)-/g, '');
  if (neg && !s.startsWith('-')) s = '-' + s;

  // Guard edge cases
  if (s === '' || s === '-' || s === '.' || s === '-.') return null;

  const num = Number(s);
  if (Number.isNaN(num)) return null;
  return { num, disp: s };
}